import { cloneDeep } from 'lodash';
import { StorageHlp } from 'src/lib/fliko/helpers/storage.helper';
import { FileInStorageVM } from '../models/file.data';
import { FireStorageService } from '../services/storage.service';

export class FileInStorageHlp {
  /**
   * Builds FileInStorageVM WITHOUT URL from storage path
   * @param {string} storagePath
   * @return {FileInStorageVM}
   */
  public static fromPath(storagePath: string | null | undefined): FileInStorageVM | null {
    return storagePath ? { storagePath, name: StorageHlp.pathToName(storagePath) } : null;
  }

  /**
   * Builds FileInStorageVM from storage url
   * @param {string} downloadUrl
   * @return {FileInStorageVM}
   */
  public static fromUrl(downloadUrl: string | null | undefined): FileInStorageVM | null {
    return downloadUrl ? { downloadUrl, ...FileInStorageHlp.fromPath(StorageHlp.urlToPath(downloadUrl))! } : null;
  }

  /**
   * Compares two FileInStorageVM objects
   * @param {FileInStorageVM} file1
   * @param {FileInStorageVM} file2
   * @return {boolean}
   */
  public static areEqual(file1: FileInStorageVM, file2: FileInStorageVM): boolean {
    return (
      file1.storagePath === file2.storagePath &&
      file1.name === file2.name &&
      file1.downloadUrl === file2.downloadUrl &&
      file1.size === file2.size
    );
  }

  /**
   * Update file sizes and return appended array
   * @param {FileInStorageVM[]}  newFiles       files to add to existing array
   * @param {FileInStorageVM[]}  filesWithSizes existing array to update
   * @param {FireStorageService} storageService service to get file sizes
   * @return {Promise<FileInStorageVM[]>}
   */
  public static async copyAndAppendFiles(
    newFiles: FileInStorageVM[],
    filesWithSizes: FileInStorageVM[],
    storageService: FireStorageService
  ): Promise<FileInStorageVM[]> {
    const copy = cloneDeep(filesWithSizes);
    for (const file of newFiles) {
      if (!copy.find((x) => x.storagePath == file.storagePath)) {
        try {
          if (!file.size) file.size = (await storageService.getMetadata(file.storagePath)).size;
        } catch (e) {
          console.warn(e);
        }
        copy.push(file);
      }
    }
    return copy;
  }
}
